(() => {
  const drawerSelector = '#ftf-search-hidden';
  const storageKey = 'recIntentLane';
  const routes = {
    apparel: { title: 'YOU WERE SHOPPING APPAREL.', label: 'BACK TO APPAREL', href: '/collections/apparel', placeholder: 'Try “western tee” or “funny nurse shirt”...' },
    fast: { title: 'YOU SAID YOU NEED IT FAST.', label: 'READY TO SHIP', href: '/collections/ready-to-ship-items', placeholder: 'Try “ready to ship” or a product name...' },
    dtf: { title: 'YOU WERE PRESSING SHIRTS.', label: 'BUILD A GANG SHEET', href: '/products/build-your-own-gang-sheet', placeholder: 'Try “DTF nurse transfer” or “horror transfer”...' },
    tumblers: { title: 'YOU WERE SHOPPING TUMBLERS.', label: 'SHOP TUMBLERS', href: '/collections/tumblers', placeholder: 'Try “engraved tumbler” or “football tumbler”...' },
    custom: { title: 'YOU WANTED SOMETHING CUSTOM.', label: 'START CUSTOM', href: '/pages/contact-us', placeholder: 'Search for inspiration, then tell REC what to build...' }
  };
  const lanes = [
    ['NEW DROPS','/collections/new-drops'],
    ['APPAREL','/collections/apparel'],
    ['DTF','/collections/dtf-transfers'],
    ['TUMBLERS','/collections/tumblers'],
  ];

  const readRoute = () => { try { return routes[sessionStorage.getItem(storageKey)] || null; } catch (e) { return null; } };
  const make = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text) el.textContent = text; return el; };

  const enhance = (drawer) => {
    if (!drawer) return;
    const header = drawer.querySelector('.ftf-drawer__header');
    if (header) {
      header.classList.add('rec-psearch__header');
      const vendorTitle = header.querySelector(':scope > .is--login');
      if (vendorTitle) vendorTitle.classList.add('rec-psearch__vendor-title');
      if (!header.querySelector('[data-rec-psearch-brand]')) {
        const brand = make('div','rec-psearch__brand');
        brand.dataset.recPsearchBrand = 'true';
        brand.append(make('span','rec-psearch__kicker','REC SEARCH'));
        brand.append(make('strong','', 'FIND YOUR SHIT.'));
        const close = header.querySelector('[data-drawer-close]');
        header.insertBefore(brand, close || header.firstChild);
      }
    }

    const form = drawer.querySelector('[data-frm-search]');
    const input = drawer.querySelector('[data-input-search]');
    if (form) form.classList.add('rec-psearch__form');
    const route = readRoute();
    if (input && !input.value.trim()) input.placeholder = route ? route.placeholder : 'Try “dark nurse shirt” or “western tee”...';

    if (form && !drawer.querySelector('[data-rec-psearch-lanes]')) {
      const nav = make('nav','rec-psearch__lanes');
      nav.dataset.recPsearchLanes = 'true';
      nav.setAttribute('aria-label','REC shopping shortcuts');
      lanes.forEach(([label, href]) => {
        const link = make('a','rec-psearch__lane',label);
        link.href = href;
        nav.append(link);
      });
      const finder = make('a','rec-psearch__lane rec-psearch__lane--finder','OPEN REC FINDER');
      finder.href = '/search';
      nav.append(finder);
      form.insertAdjacentElement('afterend', nav);
    }

    const oldRoute = drawer.querySelector('[data-rec-psearch-route]');
    if (!route && oldRoute) oldRoute.remove();
    if (route && form && !oldRoute) {
      const box = make('aside','rec-psearch__route');
      box.dataset.recPsearchRoute = 'true';
      const copy = make('div','rec-psearch__route-copy');
      copy.append(make('span','', 'FROM YOUR REC ROUTER'));
      copy.append(make('strong','', route.title));
      const link = make('a','',route.label);
      link.href = route.href;
      box.append(copy, link);
      form.insertAdjacentElement('beforebegin', box);
    }

    const title = drawer.querySelector('[data-title-search]');
    if (title) {
      const hasQuery = Boolean(input && input.value.trim());
      const nextTitle = hasQuery ? 'REC MATCHES' : 'START HERE';
      if (title.textContent.trim() !== nextTitle) title.textContent = nextTitle;
    }

    drawer.querySelectorAll('.ftf-mini-search__viewAll').forEach(link => link.setAttribute('data-rec-search-action','true'));
  };

  const mount = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer || drawer.dataset.recPsearchMounted === 'true') return;
    drawer.dataset.recPsearchMounted = 'true';
    let queued = false;
    const run = () => { queued = false; enhance(drawer); };
    const queue = () => { if (queued) return; queued = true; requestAnimationFrame(run); };
    enhance(drawer);
    new MutationObserver(queue).observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('input', (event) => { if (event.target.matches('[data-input-search]')) queue(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
